import React from 'react';

interface StatCardProps {
  label: string;
  value: number | string;
  color?: string;
  sub: string;
}

export const StatCard = React.memo(function StatCard({ label, value, sub }: StatCardProps) {
  return (
    <div className="flex-1 rounded stat-card-compact">
      <div className="text-xs ff-secondary fw-600 uppercase ls-wider mb-2 stat-card-label">{label}</div>
      <div className="ff-primary fw-700 stat-card-value-compact">{value}</div>
      <div className="text-xs ff-secondary mt-2 stat-card-sub">{sub}</div>
    </div>
  );
});
